export default {
      id: "icon-mail-usage",
      viewBox: "0 0 40 40",
      url: __webpack_public_path__ + "icons.svg#icon-mail",
      toString: function () {
        return this.url;
      }
    }